import { render, staticRenderFns } from "./PriceOfferIndexPage.vue?vue&type=template&id=53109b94"
import script from "./PriceOfferIndexPage.vue?vue&type=script&lang=js"
export * from "./PriceOfferIndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports